import { autoinject } from 'aurelia-framework';
import { HOME_ROUTE } from 'support/settings';
import { FeatureService } from '../services/features-service';
import { requireServices } from '../support/activation';

@autoinject
export class HomeWelcomeScreen {
  items: Array<object> = [];

  constructor(private featureService: FeatureService) { }

  async canActivate() {
    await requireServices(this.featureService);
  }

  activate() {
    this.items = [
      { class: '--requests', icon: 'fas fa-business-time', title: 'Travel Requests', text: 'Request security approval to travel and view requests', button: 'Make a Request', url: `#/${HOME_ROUTE}/requests` },
      //{ class: '--holidays', icon: 'fas fa-umbrella-beach', title: 'Holiday Planner', text: 'Notify us of your holiday plans', button: 'Plan Your Holiday', url: `#/${HOME_ROUTE}/holidays` },
      { class: '--countries', icon: 'fas fa-globe-africa', title: 'Travel Approvals', text: 'Check the current Travel Approval levels by country', button: 'View Travel Approvals', url: `#/${HOME_ROUTE}/countries` },
      { class: '--deviation-requests', icon: 'fas fa-clipboard-check', title: 'Deviation Requests', text: 'Request deviation for your travel and view deviations', button: 'Request Deviation', url: `#/${HOME_ROUTE}/deviationRequests` },
      { class: '--airlines', icon: 'fas fa-plane-departure', title: 'Airlines Rating', text: 'Check for approved or non-approved airlines', button: 'View Airlines', url: `#/${HOME_ROUTE}/airlines` },
      { class: '--contacts', icon: 'fas fa-envelope', title: 'Contacts', text: 'Any issues? Contact us using the channels provided', button: 'View Contact Info', url: `#/${HOME_ROUTE}/contacts` }
    ];

    if (this.featureService.contactWebUrl)
      this.items.splice(4, 0, { class: '--website', icon: 'fas fa-external-link-alt', title: 'TravelSafe Website', text: 'Visit our website to read the latest info about travel safety', button: 'Visit Our Website', url: this.featureService.contactWebUrl });
  }
}
